export default __webpack_public_path__ + "static/media/SBIR_logo_200dpi.55bbe925.jpg";